/**
 * --------------------------------------------------------------------------
 * Basic Modules: MobileMenu.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'mobileMenu';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    subMenuAnimateTime      : 300,
};

const Event = {
    RESIZE                  : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL                  : `scroll${EVENT_KEY}`,
    CLICK                   : `click${EVENT_KEY}`,
};

const ClassName = {
    SUBMENU_ACTIVE          : 'sub-menu-active',
    MENU_ACTIVE             : 'menu-active',
    SECTION_HEADING_ACTIVE  : 'mobile-menu__section-header__active',
    SUBMENU_LABEL_LINK      : 'js-sub-menu-label-link',
};

const Selector = {
    NAV_ITEM                : '.js-contains-sub-menu',
    SUBMENU                 : '.js-sub-menu',
    SUBMENU_BUTTON          : '.js-sub-menu-button',
    SUBMENU_BACK_BUTTON     : '.js-sub-menu-back-button',
    LINK_BUTTON             : '[data-target]',
    SECTION_HEADER          : '.mobile-menu__section-header',
    HEADER_TOP_NAV          : '[data-header-top-nav]',
    SUBMENU_LABEL_LINK      : '.js-sub-menu-label-link',
};

//const DataAttr = {};

class MobileMenu {

    constructor(config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._config  = this._getConfig(config);

        this.navItems = Array.from(document.querySelectorAll(Selector.NAV_ITEM));

        this._addEventListeners();

        this._setup();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _setup() {

        const self = this;

        this.navItems.forEach(function(elem) {

            let subMenuButton = elem.querySelector(Selector.SUBMENU_BUTTON);
            let subMenuContainer = elem.querySelector(Selector.SUBMENU);
            let subMenuBackButton = elem.querySelector(Selector.SUBMENU_BACK_BUTTON);
            let subMenuLabelLink = elem.querySelector(Selector.SUBMENU_LABEL_LINK);
            //let headerTopNav = elem.querySelector(Selector.HEADER_TOP_NAV);

            if (! subMenuButton || ! subMenuBackButton) {
                console.warn('Element', elem, 'is missing', subMenuButton, Selector.SUBMENU, 'or', Selector.SUBMENU_BACK_BUTTON);
                return;
            }

            // if (headerTopNav) {
            //     let headerTopItems = headerTopNav.querySelectorAll('li');
            //
            //     $(headerTopItems).each((idx, element) => {
            //         element.clone().appendTo($('.mobile-menu'));
            //     });
            // }

            subMenuButton.addEventListener('click', function(event) {

                if (! event.target.classList.contains(ClassName.SUBMENU_LABEL_LINK)) {
                    elem.parentNode.parentNode.classList.add(ClassName.SUBMENU_ACTIVE);
                    subMenuContainer.classList.add(ClassName.MENU_ACTIVE);
                }

            });

            subMenuBackButton.addEventListener('click', () => {
                elem.parentNode.parentNode.classList.remove(ClassName.SUBMENU_ACTIVE);

                setTimeout(() => {
                    // Allow the animation to complete before disabling the submenu.
                    subMenuContainer.classList.remove(ClassName.MENU_ACTIVE);
                }, self._config.subMenuAnimateTime);
            })
        });
    }

    _resetMobileMenu() {
        this.navItems.forEach((elem) => {
            let subMenuContainer = elem.querySelector(Selector.SUBMENU);
            elem.parentNode.parentNode.classList.remove(ClassName.SUBMENU_ACTIVE);
            subMenuContainer.classList.remove(ClassName.MENU_ACTIVE);
        });
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(window).on(`closemobilemenu`, () => this._resetMobileMenu());
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     */
    static init (config) {
        new MobileMenu(config);
    }
}

export default MobileMenu;
